import { dayjsNow, parseDayJs } from '@/Infrastructure/Utilities/dayjs.type';
import { GridFilterOperator } from '@mui/x-data-grid-pro';
import dayjs, { Dayjs } from 'dayjs';

/**
 * Custom Grid Filter Operator to apply date filtering operations after today
 */
export const DateAfterTodayOperator: GridFilterOperator = {
	getApplyFilterFn: (filterItem) => {
		if (!filterItem.field || !filterItem.operator) {
			return () => false;
		}

		const filterEpoch = dayjsNow().valueOf();

		return (value) => {
			if (typeof value === 'string') {
				const columnEpoch = parseDayJs(value)?.valueOf() ?? 0;
				return columnEpoch > filterEpoch;
			}

			return false;
		};
	},
	value: '> Today'
};

export const DateBeforeOrEqualToValueOperator: GridFilterOperator = {
	getApplyFilterFn: (filterItem) => {
		if (!filterItem.field || !filterItem.operator) {
			return () => false;
		}

		const filterEpoch = (filterItem.value as Dayjs).valueOf();

		return (value) => {
			if (dayjs.isDayjs(value)) {
				return value.valueOf() <= filterEpoch;
			}

			if (typeof value === 'string') {
				const columnEpoch = parseDayJs(value)?.valueOf() ?? 0;
				return columnEpoch <= filterEpoch;
			}

			return false;
		};
	},
	value: '<='
};

export const DateAfterOrEqualToValueOperator: GridFilterOperator = {
	getApplyFilterFn: (filterItem) => {
		if (!filterItem.field || !filterItem.operator) {
			return () => false;
		}

		const filterEpoch = (filterItem.value as Dayjs).valueOf();

		return (value) => {
			if (dayjs.isDayjs(value)) {
				return value.valueOf() >= filterEpoch;
			}

			if (typeof value === 'string') {
				const columnEpoch = parseDayJs(value)?.valueOf() ?? 0;
				return columnEpoch >= filterEpoch;
			}

			return false;
		};
	},
	value: '>='
};

/**
 * Custom Grid Filter Operator to apply Not Equal to operations
 */
export const DoesNotEqual: GridFilterOperator = {
	getApplyFilterFn: (filterItem) => {
		if (!filterItem.field || !filterItem.operator) {
			return () => true;
		}

		return (value) => {
			if (typeof value === 'string' && typeof filterItem.value === 'string') {
				return (
					value.localeCompare(filterItem.value, 'en', {
						sensitivity: 'base'
					}) !== 0
				);
			}

			return true;
		};
	},
	value: '!='
};
